import styled from 'styled-components';
import { ReactComponent as CurveImg } from 'products/global/assets/img/join-us/timeline-curve.svg';
import { motion } from 'framer-motion6';
import { sizes } from 'style';

export const TimelineBackground = styled.div`
  position: relative;
  width: 100%;
`;

export const TimelineContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.turquoise};
  width: 100%;
  overflow: hidden;
  cursor: grab;
  padding-top: 50px;
  padding-bottom: 50px;

  :active {
    cursor: grabbing;
  }

  @media ${sizes.tabletLandscape} {
    padding-top: 100px;
    padding-bottom: 70px;
  }
`;

export const Curve = styled(CurveImg)`
  position: relative;
  width: calc(100% + 0.4px);
  margin-top: -1px;
`;

export const Track = styled(motion.div)`
  display: flex;
  flex-wrap: nowrap;
  min-width: min-content;
`;

export const TrackWrapper = styled.div`
  position: relative;
`;
